import { render, staticRenderFns } from "./TrendsTable.vue?vue&type=template&id=6b15ba4c&"
import script from "./TrendsTable.vue?vue&type=script&lang=js&"
export * from "./TrendsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports